import { AlertTriangle, Layers3, Loader2 } from "lucide-react";
import { BACKING_PHASES } from "@/lib/studioApi";

/** Step 1 of "Sing it myself": split the AI vocal from the music (and find your duet parts). */
export default function BackingPrep({ backing, onPrepare, busy }) {
  const status = backing?.status || "none";
  if (status === "running") {
    return (
      <div data-testid="backing-progress" data-phase={backing.phase} className="rounded-3xl border border-blue-400/30 bg-blue-500/[0.08] p-6">
        <p className="flex items-center gap-2 text-sm text-blue-100"><Loader2 className="h-4 w-4 animate-spin" /> <span data-testid="backing-phase">{BACKING_PHASES[backing.phase] || "Working"}…</span></p>
        <p className="mt-2 text-[12px] text-white/55">Usually under a minute. You can stay here — the recorder opens as soon as it's ready.</p>
      </div>
    );
  }
  return (
    <div data-testid="backing-prep" className="rounded-3xl border border-white/[0.08] bg-[#0a0d1c]/80 p-6">
      {status === "error" ? (
        <p data-testid="backing-error" className="mb-4 flex items-start gap-2 rounded-2xl border border-rose-400/40 bg-rose-500/10 px-4 py-3 text-[13px] text-rose-100"><AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />{backing.error}</p>
      ) : null}
      <p className="font-display text-lg font-semibold">First, ELPM makes your backing track</p>
      <p className="mt-1.5 text-[13px] leading-relaxed text-white/60">It takes any AI vocal out of the music, so you sing over the instruments — for duets it keeps your partner's parts and leaves yours open.</p>
      <button type="button" data-testid="backing-prepare-btn" onClick={onPrepare} disabled={busy} className="mt-5 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-blue-500 to-violet-600 px-6 py-3 font-display text-sm font-semibold disabled:opacity-40">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Layers3 className="h-4 w-4" />} {status === "error" ? "Try again" : "Prepare backing track"}
      </button>
    </div>
  );
}
